import Text from 'common-components/Text'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { RADII } from 'styles/consts'
import styled from 'styled-components'
import {
  flexCenterMixin,
  hideScrollbarMixin,
  absoluteElementToCenterMixin
} from 'styles/mixins'

export const MusicLibraryWrapper = styled.div`
  gap: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 70px;

  width: 100%;
  flex: 1;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding-top: 12px;
    padding-bottom: 12px;
    overflow-y: auto;
    ${hideScrollbarMixin()}
  }
`

export const MusicLibItem = styled.div<{
  $background: string
}>`
  position: relative;
  background: ${props => `url(${props.$background})`};
  background-size: cover;
  background-position: center;
  width: 100%; /* Fill the grid cell */
  min-height: 0px;
  border-radius: ${RADII.item};
  cursor: pointer;
  ${flexCenterMixin()}
  transition: transform 0.3s;

  &:hover {
    &::after {
      content: '';
      position: absolute;
      border-radius: 10px;
      inset: -3px;
      border: 2px solid ${COLORS.primaryDark};
    }
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    min-height: 60px;

    &:hover {
      &::after {
        display: none;
      }
    }
  }
`

export const MusicLibItemLabel = styled(Text)`
  position: absolute;
  width: max-content;
  height: max-content;
  ${absoluteElementToCenterMixin()}
`
